export default (raceData, isAllRaceDiscontinuation, isAllRaceComingSoon, isSp) => {

  const r = {
    data: {
      race: raceData,
    },
    isAllRaceDiscontinuation,
    isAllRaceComingSoon,
    isSp
  };
  const init = () => {
    console.log('buildMigratoryRace', r.data);
    r.root = document.querySelector('.le-migratory-race').parentElement;

    buildAccordion();
    // buildDrum();

    r.root.classList.remove('_skelton');
    r.root.removeAttribute('aria-hidden');
  }

  const buildAccordion = () => {
    const raceList = r.root.querySelector('.le-migratory-race__list');
    const raceListItem = raceList.firstElementChild;
    // console.log(raceListItem);

    const fragmentElement = document.createDocumentFragment();
    const dropdownTargetText = r.root.querySelector('.le-migratory-dropdown__target-txt');
    if ((r.isAllRaceDiscontinuation || r.isAllRaceComingSoon) && r.isSp) {
      r.root.classList.add('_disabled')
      r.root.querySelector('.le-migratory-race__list').className = '';
      dropdownTargetText.innerHTML = r.isAllRaceDiscontinuation
        ? generateDiscontinuationDorpdownStr(r.data.race)
        : 'COMING SOON';
      dropdownTargetText.nextElementSibling.remove();
    } else {
      r.data.race.forEach(raceInfoObj => {
        const cloneListItem = raceListItem.cloneNode(true);
        if (raceInfoObj.isCurrent) {
          cloneListItem.classList.add('is-current');
          dropdownTargetText.innerHTML = createDiscontinuationDorpdownStr(raceInfoObj.num, raceInfoObj.title);
        }

        const txt = cloneListItem.querySelector('.le-migratory-race__link-txt');
        txt.innerHTML = `<span class="le-migratory-race__link-num">${raceInfoObj.num}</span><span class="le-migratory-race__link-name">${raceInfoObj.title}</span>`;

        if (raceInfoObj.isRaceComing || raceInfoObj.isRaceDiscontinuation) {
          const noLinkElement = document.createElement('div');
          noLinkElement.classList.add('le-migratory-race__link', '_disabled');
          noLinkElement.appendChild(txt);
          cloneListItem.innerHTML = '',
          cloneListItem.appendChild(noLinkElement);
        } else {
          const link = cloneListItem.querySelector('.le-migratory-race__link');
          link.href = `/league/racecard/?race_id=${raceInfoObj.id}`;
        }

        fragmentElement.appendChild(cloneListItem);
      });
    }

    raceList.innerHTML = '';
    raceList.appendChild(fragmentElement);
  }

  init();
}

const createDiscontinuationDorpdownStr = (num, title) => {
  return `<span class="le-migratory-dropdown__target-num">${num}</span><span class="le-migratory-dropdown__target-name">${title}</span>`;
}
const generateDiscontinuationDorpdownStr = (raceData) => {
  const currentRaceObj = raceData.filter(raceInfoObj => raceInfoObj.isCurrent)[0];
  return createDiscontinuationDorpdownStr(currentRaceObj.num, currentRaceObj.title)
}
